import {
  imSetToArray,
  imSetToObj,
} from '@client/shared/utils/immutableUtils/immutableUtils';
import {
  PUT_AND_HANDLE_ADMIN_INFO,
  UPDATE_PARTICIPANT_BLACKLIST,
} from '@client/redux/participant/participantReducer';

export const INFLUENCER_REDUCER_KEY = 'influencerReducer';

export const DELETE_AND_HANDLE_INFLUENCERS = 'DELETE_AND_HANDLE_INFLUENCERS';
export const SET_INFLUENCER_ERROR = 'SET_INFLUENCER_ERROR';
export const POST_AND_HANDLE_INFLUENCER_NOTIFICATION =
  'POST_AND_HANDLE_INFLUENCER_NOTIFICATION';
export const UPDATE_INFLUENCER_ROLE = 'UPDATE_INFLUENCER_ROLE';
export const UPDATE_INFLUENCER_LISTS = 'UPDATE_INFLUENCER_LISTS';
export const SET_INFLUENCER_LISTS = 'SET_INFLUENCER_LISTS';

/* DEFAULT CAMPAIGN STATE */
let defaultState = {
  influencers: [],
  influencerLists: [],
};

/* REDUCER */
export default function(state = defaultState, action = {}) {
  switch (action.type) {
    case UPDATE_PARTICIPANT_BLACKLIST: {
      const { influencerId, checked } = action.payload;

      const updatedInfluencers = state.influencers.map((influencer) => {
        if (influencer.id === influencerId) {
          return imSetToObj(influencer, 'blacklisted', checked);
        } else {
          return influencer;
        }
      });

      return {
        ...state,
        influencers: updatedInfluencers,
      };
    }
    case UPDATE_INFLUENCER_ROLE: {
      const { data, influencerId } = action.payload;
      const {
        influencer: { role },
      } = data;
      const updatedInfluencers = state.influencers.map((influencer) => {
        if (influencer.id === influencerId) {
          return imSetToObj(influencer, 'role', role);
        } else {
          return influencer;
        }
      });

      return {
        ...state,
        influencers: updatedInfluencers,
      };
    }
    case POST_AND_HANDLE_INFLUENCER_NOTIFICATION: {
      //TODO
      return state;
    }
    case PUT_AND_HANDLE_ADMIN_INFO: {
      const indexOfInfluencerToUpdate = state?.influencers?.findIndex(
        (influencer) => influencer.id === action.payload.influencer.id
      );
      if (indexOfInfluencerToUpdate >= 0) {
        return {
          ...state,
          influencers: imSetToArray(
            state.influencers,
            action.payload.influencer,
            'id'
          ),
        };
      } else {
        return state;
      }
    }
    case DELETE_AND_HANDLE_INFLUENCERS: {
      //TODO
      return state;
    }
    case SET_INFLUENCER_ERROR: {
      //TODO
      return state;
    }
    case SET_INFLUENCER_LISTS: {
      const { data } = action.payload;
      return {
        ...state,
        influencerLists: data,
      };
    }
    default:
      return state;
  }
}
